import { connect } from 'react-redux';

import { updateFormValue } from '../../../../actions/form';
import { getFormError } from '../../../../selectors/form';

import { TICKET_EMAIL } from '../../../../constants/ticketTypes';

import TicketEmail from './TicketEmail';

const mapStateToProps = (state) => ({
    error: getFormError(state, { id: TICKET_EMAIL }),
});

const mapDispatchToProps = {
    updateFormValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketEmail);
